module.exports = __webpack_public_path__ + "static/röver-office-6e92e4c5596ab3489e694fdbeb65f79a.jpg";